import { render, staticRenderFns } from "./weixinAccountManage.vue?vue&type=template&id=5589dc23&scoped=true"
import script from "./weixinAccountManage.vue?vue&type=script&lang=js"
export * from "./weixinAccountManage.vue?vue&type=script&lang=js"
import style0 from "./weixinAccountManage.vue?vue&type=style&index=0&id=5589dc23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5589dc23",
  null
  
)

export default component.exports